/*
 * "Discussões relacionadas" (por embeddings): no fim do
 * tópico, antes dos sugeridos, os tópicos mais parecidos no significado — não
 * só nas palavras.
 *
 * O servidor devolve a lista pronta (já filtrada pelo que a pessoa vê, na
 * ordem da semelhança). A tabela reusa as classes dos sugeridos: as duas
 * listas são a mesma peça, com títulos
 * diferentes.
 */
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import Icon from 'flarum/common/components/Icon';
import abbreviateNumber from 'flarum/common/utils/abbreviateNumber';
import { categoryBadge, labelBadge } from '../../utils/tags';
import { fullDate, shortAge } from '../../utils/dates';
import { t } from '../../utils/settings';
import { aiRequest } from './state';
/** Uma busca por tópico: a linha do fim aparece e some conforme o stream carrega. */
const cache = new Map();
export default class RelatedTopics extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    const id = this.attrs.discussion.id();
    if (cache.has(id)) return;
    cache.set(id, []);
    aiRequest('GET', `related/${id}`).then(response => cache.set(id, response.data || [])).catch(() => {}).finally(() => m.redraw());
  }
  view() {
    const topics = cache.get(this.attrs.discussion.id()) || [];
    if (!topics.length) return null;
    return m("section", {
      className: "CanelaSuggested CanelaAiRelated related-topics",
      "aria-labelledby": "canela-ai-related-title"
    }, m("h2", {
      className: "CanelaSuggested-title",
      id: "canela-ai-related-title"
    }, m(Icon, {
      name: "fas fa-wand-magic-sparkles"
    }), " ", t('ai.related.title')), m("table", {
      className: "CanelaSuggested-table"
    }, m("thead", null, m("tr", null, m("th", {
      scope: "col",
      className: "CanelaSuggested-topicHead"
    }, t('ai.related.topic')), m("th", {
      scope: "col",
      className: "CanelaSuggested-num"
    }, t('ai.related.replies')), m("th", {
      scope: "col",
      className: "CanelaSuggested-num"
    }, t('ai.related.activity')))), m("tbody", null, topics.map(topic => this.row(topic)))));
  }
  row(topic) {
    const last = topic.lastPostedAt ? new Date(topic.lastPostedAt) : null;
    const tags = topic.tagIds.map(id => app.store.getById('tags', id)).filter(Boolean);
    return m("tr", {
      className: "CanelaSuggested-row"
    }, m("td", {
      className: "CanelaSuggested-topic"
    }, m(Link, {
      className: "CanelaSuggested-link",
      href: topic.url
    }, topic.title), tags.length > 0 && m("div", {
      className: "CanelaSuggested-badges"
    }, m("span", {
      className: "CanelaBadges"
    }, tags.map(tag => tag.position() !== null ? categoryBadge(tag) : labelBadge(tag))))), m("td", {
      className: "CanelaSuggested-num CanelaSuggested-replies"
    }, abbreviateNumber(topic.replyCount)), m("td", {
      className: "CanelaSuggested-num CanelaSuggested-activity",
      title: last ? fullDate(last) : ''
    }, last ? shortAge(last) : ''));
  }
}
flarum.reg.add('ramon-canela', 'forum/features/ai/RelatedTopics', RelatedTopics);